// extracted by mini-css-extract-plugin
module.exports = {"arrowLink":"BackButton_arrowLink__2iu_p","arrowLinkIcon":"BackButton_arrowLinkIcon__21Edl"};